import qs from 'qs'
// @ts-ignore
import fileSaver from 'file-saver'
import queryClient from 'app/queryClient'
import liveReportService from './instance'
import getFileNameFromHeader from '../utils/exportUtil'

export async function getPageConfig() {
  const data = {
    page: 'CB_WEB'
  }
  const response = await queryClient.fetchQuery(['/proxy/getPageConfig', data], () =>
    liveReportService.post('/proxy/getPageConfig', qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  )
  return response
}

export async function runSearch(
  dashboardId: number,
  dashboardName: string,
  spec: any,
  widgetId?: number | string,
  timestamp?: number,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _requestConfig?: unknown,
  llmWordCloud?: boolean
) {
  const data = {
    dashboardId,
    dashboardName,
    spec: JSON.stringify(spec),
    searchInfo: false, // TODO: originally from window.searchInfo
    // Mirror src/api.ts behavior so live-report viewers get the same opt-in
    // LLM Word Cloud path as logged-in dashboard users. The 6th positional
    // arg slot is reserved to keep the runSearch signature shape-compatible
    // with src/api.ts (which has a requestConfig parameter we don't need here).
    ...(llmWordCloud ? { llm_wordcloud: true } : {})
  }
  const response = await queryClient.fetchQuery(
    ['/proxy/runSearches', timestamp, widgetId, data],
    () =>
      liveReportService.post('/proxy/runSearches', qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
  )
  return response
}

export async function exportPdf(
  html: string,
  filename: string,
  windowWidth: number,
  windowHeight: number,
  pageHeight?: number
) {
  let data = {
    html: JSON.stringify(html),
    filename: JSON.stringify(filename),
    windowWidth: windowWidth.toString(),
    windowHeight: windowHeight.toString()
  } as any

  if (pageHeight) {
    data = {
      ...data,
      pageHeight: pageHeight.toString()
    }
  }

  const response = await queryClient.fetchQuery(['/proxy/generateV4Pdf', data], () =>
    liveReportService.post('/proxy/generateV4Pdf', qs.stringify(data), {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7'
      }
    })
  )

  const fileName = getFileNameFromHeader(response.headers['content-disposition'])
  const blob = new Blob([response.data], { type: 'application/pdf' })
  fileSaver.saveAs(blob, fileName || 'dashboard_export.pdf')
}

export async function retrieveEmojis() {
  const data = {}
  const response = await queryClient.fetchQuery(['/proxy/retrieveEmojis', data], () =>
    liveReportService.post('/proxy/retrieveEmojis', qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  )
  return response
}

export async function getDashboardByReportId(id: string) {
  const response = await queryClient.fetchQuery(['/v1/dashboard', id], () =>
    liveReportService.get('/v1/dashboard')
  )
  return response
}

export async function heartbeat() {
  const response = await queryClient.fetchQuery(
    ['/v1/heartbeat'],
    () => liveReportService.get('/v1/heartbeat'),
    // override staleTime to 0 to always fetch the latest state
    {
      staleTime: 0
    }
  )
  return response
}

export async function getReportConfig() {
  const response = await queryClient.fetchQuery(['/v1/reportConfig'], () =>
    liveReportService.get('/v1/reportConfig')
  )
  return response
}

export async function logout() {
  const response = await queryClient.fetchQuery(
    ['/v1/logout'],
    () => liveReportService.post('/v1/logout'),
    // override staleTime to 0 to always fetch the latest state
    {
      staleTime: 0
    }
  )
  return response
}

/*
 * For unprotected reports, the LiveReportService performs an auto-login behind the scenes,
 * then responds with a valid session and CSRF token.
 */
export async function csrfToken() {
  const response = await queryClient.fetchQuery(
    ['/v1/csrfToken'],
    () => liveReportService.get('/v1/csrfToken'),
    // override staleTime to 0 to always fetch the latest csrf token
    {
      staleTime: 0
    }
  )
  return response
}

export async function login(data: { email: string; reportKey: string }) {
  const response = await queryClient.fetchQuery(
    ['/v1/login', data],
    () => liveReportService.post('/v1/login', data),
    // override staleTime to 0 to always fetch the latest state
    {
      staleTime: 0
    }
  )
  return response
}
